import type { IApiErrorPlain } from '@platform/core/types';
import { ApiError } from '@platform/dao';

/** Помилка мутації RTK Query (`unwrap` віддає вже просту IApiErrorPlain) або будь-яка інша — у вигляді для ErrorBanner. Чиста функція. */
export function asPlainError(e: unknown): IApiErrorPlain {
  if (e && typeof e === 'object' && 'message' in e && 'status' in e) return e as IApiErrorPlain;
  return ApiError.fromUnknown(e);
}

/** Чи сервер ще не має цієї дії (маршрут не знайдено або метод не дозволено) — інтерфейс тоді пояснює це, а не показує сиру помилку. */
export function isUnsupported(e: IApiErrorPlain | null | undefined): boolean {
  return Boolean(e && (e.status === 404 || e.status === 405 || e.status === 501));
}
